import { useCallback } from 'react';
import { debounce } from 'underscore';

const useDebouncedCallback = (callback, dependency = [], wait = 3000) => {
  return useCallback(debounce(callback, wait, true), dependency);
};

export default useDebouncedCallback;
